export default {
  create: {
    success: 'Gabarit créé avec succès',
    error: 'Impossible de créer ce gabarit'
  },
  update: {
    success: 'Modification sur le gabarit effectué avec succès',
    error: 'Impossible de modifier le gabarit'
  },
  delete: {
    success: 'Gabarit supprimé avec succès',
    error: 'Impossible de supprimer le gabarit'
  }
}
